import * as actionTypes from '../action-types';
import { AggregationsActions, QueryParamsActions } from '../actions';
import { aggregationSeparator } from '../utils/constants';

export type AggregationsTreeType = { selectedPanes: Array<string> };

export const defaultState: AggregationsTreeType = {
  selectedPanes: [],
};

function getNextState(
  previous: Array<string>,
  path: Array<string>,
  value: boolean,
) {
  const [domain, ...subs] = path;
  const allPaths = subs.reduce<Array<string>>((acc, key, index) => {
    const prefix = index === 0 ? domain : acc[index - 1];
    acc.push(`${prefix}${aggregationSeparator}${key}`);
    return acc;
  }, []);

  let newSelectedPanes;

  if (value) {
    const previousSet = new Set(previous);
    allPaths.forEach(item => previousSet.add(item));
    newSelectedPanes = Array.from(previousSet);
  } else {
    const aggregationPathFormated = path.join(aggregationSeparator);

    newSelectedPanes = previous.filter(
      selectedPane =>
        selectedPane !== aggregationPathFormated &&
        selectedPane.indexOf(
          `${aggregationPathFormated}${aggregationSeparator}`,
        ) === -1,
    );
  }
  return newSelectedPanes;
}

export function aggregationsTreeReducer(
  state = defaultState,
  action: AggregationsActions | QueryParamsActions,
) {
  switch (action.type) {
    case actionTypes.TOGGLE_AGGREGATION: {
      const { aggregationPath, value } = action.payload;
      return {
        selectedPanes: getNextState(
          state.selectedPanes,
          aggregationPath,
          value,
        ),
      };
    }

    case actionTypes.TOGGLE_AGGREGATION_PANE: {
      const { path, isExpanded } = action.payload;

      return {
        selectedPanes: getNextState(state.selectedPanes, path, isExpanded),
      };
    }

    default:
      return state;
  }
}
